import * as React from 'react';
import { InstructionItem } from './InstructionItem';
import { FileUploadArea } from '../../FileUploadArea';

// SVG asset icons (string sources)
import quietIcon from '@/assets/images/svg/quiet_icon.svg';
import qualityIcon from '@/assets/images/svg/quality_icon.svg';
import sameIcon from '@/assets/images/svg/same_icon.svg';
import recordImage from '@/assets/images/svg/record_image.svg';

interface InitialViewProps {
  onFileSelect: (file: File) => void;
  onRecordStart: () => void;
}

export const InitialView: React.FC<InitialViewProps> = ({ onFileSelect, onRecordStart }) => (
  <div className='flex flex-col gap-8'>
    {/* Instructions Row */}
    <div className='grid grid-cols-1 gap-6 md:grid-cols-3'>
      <InstructionItem
        icon={quietIcon}
        title='Quiet Space'
        description='Record in a noise-free environment'
      />

      <InstructionItem icon={qualityIcon} title='Quality' description='Use a quality microphone' />

      <InstructionItem
        icon={sameIcon}
        title='Same Device'
        description='Keep equipment consistent'
      />
    </div>

    {/* Drop area + OR + Record — 10px spacing between each */}
    <div className='flex flex-col items-center gap-[10px]'>
      <FileUploadArea onFileSelect={onFileSelect} />

      <span className='font-sans text-16 font-medium leading-27 text-dark-100'>OR</span>

      <button
        type='button'
        onClick={onRecordStart}
        className='group flex flex-col items-center gap-4 transition-transform hover:scale-105 active:scale-95'
      >
        <img src={recordImage} alt='Record' className='h-auto w-[148px]' />

        <span className='font-proxima text-20 font-bold leading-105 text-dark-300 underline decoration-solid decoration-auto underline-offset-0'>
          Click to Record Audio
        </span>
      </button>

      <span className='text-center font-sans text-16 font-medium leading-20 text-black'>
        Minimum 10 seconds audio required
      </span>
    </div>
  </div>
);
